<template>
  <div class="AppointmentNotesHistory">
    <div class="AppointmentNotesHistory__container">
      <h2 class="AppointmentNotesHistory__title">Histórico de Anotações</h2>

      <div class="AppointmentNotesHistory__card">
        <div
          v-if="!appointmentNotes.length"
          class="AppointmentNotesHistory__loader"
        >
          <AppSpinner />
        </div>

        <ul v-else class="AppointmentNotesHistory__card-list">
          <li
            v-for="note in appointmentNotes"
            :key="note.id"
            class="AppointmentNotesHistory__card-list-item"
          >
            <div class="AppointmentNotesHistory__icon-thumb mr-4">
              <Icon
                :name="'clipboard-icon'"
                :width="28"
                :height="28"
                style="stroke:#fff;"
              />
            </div>

            <p>{{ formatDate(note.created_at) }}</p>

            <AppButton
              class="button"
              size="sm"
              outline
              @click.native="showModal(note.id)"
            >
              Visualizar
            </AppButton>
          </li>
        </ul>
      </div>
    </div>

    <b-modal id="notes-modal" ref="notes-modal" size="lg" hide-footer>
      <div class="AppointmentNotesHistory__note-output">
        <div v-html="appointmentNote" />
      </div>
    </b-modal>
  </div>
</template>

<script>
import { parseISO, format } from "date-fns";
import { pt as locale } from "date-fns/locale";
import AppButton from "../components/AppButton";
import AppSpinner from "../components/AppSpinner";
import Icon from "../components/CustomIcons.vue";

export default {
  name: "AppointmentNotesHistory",
  components: {
    Icon,
    AppButton,
    AppSpinner
  },
  data() {
    return {
      isLoading: false,
      appointmentNotes: [],
      appointmentNote: ""
    };
  },
  mounted() {
    this.fetchAppointmentNotes();
  },
  methods: {
    fetchAppointmentNotes() {
      this.isLoading = true;
      this.$store
        .dispatch("appointments/fetchAppointmentNotes", this.$route.params.id)
        .then(response => {
          this.appointmentNotes = response.data;
          this.isLoading = false;
        });
    },
    showModal(noteId) {
      this.$bvModal.show("notes-modal");
      this.appointmentNote = this.appointmentNotes.find(
        note => note.id === noteId
      ).description;
    },
    formatDate(date) {
      const firstDate = parseISO(date);

      const formattedDate = format(
        firstDate,
        "'Anotação criada dia' dd 'de' MMMM', às ' HH:mm'h'",
        { locale }
      );

      return formattedDate;
    }
  }
};
</script>

<style scoped lang="scss">
.AppointmentNotesHistory {
  width: 100%;

  &__loader {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__title {
    margin: 56px 0 32px 0;
    color: #141414;
    text-align: center;
    font-size: 28px;
    font-family: Inter, sans-serif;
    font-weight: 600;
    line-height: 120%;
    letter-spacing: -0.5px;
  }

  &__container {
    padding: 1.5rem 1rem;
    width: 100%;
    height: 100%;
    max-width: 780px;
    margin: 0 auto;
  }

  &__card {
    padding: 32px;
    border-radius: 12px;
    background: #fff;
    box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.08);

    &-list {
      display: block;
      margin: 0;
      padding: 0;
      list-style: none;

      &-item {
        display: flex;
        align-items: center;
        padding: 1rem 0;

        &:not(:last-child) {
          border-bottom: solid 1px #dddddd;
        }

        p {
          color: #545454;
          font-size: 14px;
          font-family: Inter, sans-serif;
          line-height: 160%;
        }

        button {
          margin-left: auto;
        }
      }
    }
  }

  &__icon-thumb {
    background-color: rgba(236, 140, 179, 1);
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    border-radius: 50%;
  }

  &__note-output {
    overflow: auto;
    height: 600px;
    padding: 1rem;
  }
}
</style>
